import { render, staticRenderFns } from "./ModalEditarEvento.vue?vue&type=template&id=92ed9a06"
import script from "./ModalEditarEvento.vue?vue&type=script&lang=js"
export * from "./ModalEditarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ed9a06')) {
      api.createRecord('92ed9a06', component.options)
    } else {
      api.reload('92ed9a06', component.options)
    }
    module.hot.accept("./ModalEditarEvento.vue?vue&type=template&id=92ed9a06", function () {
      api.rerender('92ed9a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/ModalEditarEvento.vue"
export default component.exports